<ng-container *transloco="let t">
    <form [formGroup]="inputForm">
        <label *ngIf="!hideLabel" [for]="formId" class="trim-text">
            {{ label }}
            <span *ngIf="errors?.['required']">*</span>
        </label>
        <div>
            <app-dropdown #dropdown [disabled]="inputForm.disabled" [isDropdownListFullWidth]="isFullWidth" [removeArrow]="true" (openChange)="openCalendar()" (dropdownClosed)="closeDropdown()">
                <div dropdownPanel>
                    <div class="panel text-wrap" [class.error]="(inputForm.touched || isTouched || ranges) && invalid"
                         [class.disabled]="disabled">
                        <app-date-input
                                [showError]="((inputForm.touched || isTouched || ranges) && invalid) ?? false"
                                [onlyYear]="inputForm.controls.onlyYear.value ?? false"
                                formControlName="inputDate"
                                [withTime]="displayTime" [withSeconds]="displaySeconds" [withMilliseconds]="displayMilliseconds">
                        </app-date-input>
                        <button dropdownToggle class="toggle-button"
                                    [disabled]="inputForm.disabled"
                                    [class.error]="invalid && (inputForm.touched || isTouched || ranges)" >
                                <img src="assets/icons/icons-alt/calendar-04.svg" alt="Calendar">
                        </button>
                    </div>
                </div>
                <div dropdownContent>
                    <div class="dropdown-calendar-wrapper">
                        <div>
                            <ng-template [ngTemplateOutlet]="navigation"></ng-template>
                            <div>
                                @if (calendarState === CalendarState.YEAR) {
                                <ng-template [ngTemplateOutlet]="yearsSelection"></ng-template>
                                }

                                @if (calendarState === CalendarState.MONTH) {
                                <ng-template [ngTemplateOutlet]="monthSelection"></ng-template>
                                }
                                <ng-template [ngTemplateOutlet]="calendarSelection"></ng-template>

                            </div>

                            @if (displayTime) {
                            <ng-template [ngTemplateOutlet]="timeSelection"></ng-template>
                            }

                            @if (allowOnlyYearSelection) {
                            <div class="d-flex align-items-center p-3 only-year-checkbox">
                                <app-checkbox formControlName="onlyYear" label="date.time.input.onlyYear"/>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </app-dropdown>
        </div>


        <ng-template #navigation>
            <div class="calendar-navigation">
                    <div class="me-2 chevron" (click)="navigatePrevious()"
                         [ngStyle]="{'visibility': calendarState === CalendarState.MONTH ? 'hidden' : 'visible'}">
                        <i class="scale-80 bi bi-chevron-left"></i>
                    </div>

                    <div class="d-flex justify-content-center">
                        @if (!inputForm.controls['onlyYear'].value) {
                        <button class="navigator-button" (click)="changeCalendarState(CalendarState.MONTH)"
                              [ngClass]="{'selected': calendarState === CalendarState.MONTH }">
                        {{
                        t("app.common.month." + navigationDate.month)
                        }}
                        </button>
                        }
                        <button class="navigator-button" (click)="changeCalendarState(CalendarState.YEAR)"
                                [ngClass]="{'selected': calendarState === CalendarState.YEAR }">
                            {{ navigationDate.year }}
                        </button>
                    </div>
                    <div class="ms-2 chevron" (click)="navigateNext()"
                         [ngStyle]="{'visibility': calendarState === CalendarState.MONTH ? 'hidden' : 'visible'}">
                        <i class="scale-80 bi bi-chevron-right"></i>
                    </div>
            </div>
        </ng-template>

        <ng-template #calendarSelection>
            <div [ngStyle]="{'display': calendarState === CalendarState.DAY ? 'block' : 'none'}">
                <ngb-datepicker formControlName="date"
                                id="{{formId + '-date'}}"
                                [navigation]="'none'" (dateSelect)="onDateSelected($event)"
                                [minDate]="minCalendarDate"
                                [maxDate]="maxCalendarDate"
                                [startDate]="navigationDate"
                                outsideDays="hidden" #calendar="ngbDatepicker"/>
            </div>
        </ng-template>

        <ng-template #yearsSelection>
            <div class="month-and-year-wrapper">
                <div class="row row-cols-3">
                    @for (navigation of years;track navigation) {
                    <div class="col p-2">
                      <div (click)="!navigation.disabled ? yearSelected($event, (navigation.value)): null"
                           class="picker btn-light"
                           [ngClass]="{'bg-primary text-white': navigationDate.year === navigation.value,
                    'disabled': navigation.disabled,
                    'current': !(navigationDate.year === navigation.value) && currentDate.getFullYear() === navigation.value}">
                    {{ navigation.value }}
                    </div>
                  </div>
                    }
                </div>
            </div>
        </ng-template>

        <ng-template #monthSelection>
            <div class="month-and-year-wrapper">
                <div class="row row-cols-3">
                    @for (navigation of months;track navigation) {
                    <div class="col p-2">
                      <div (click)="!navigation.disabled ? monthSelected($event, navigation.value) : null"
                           class="picker btn-light" [ngClass]="{
                    'bg-primary text-white': navigationDate.month === navigation.value,
                    'disabled': navigation.disabled,
                    'current': !(navigationDate.month === navigation.value) &&
                    currentDate.getFullYear() === navigationDate.year && currentDate.getMonth()+1 === navigation.value
                    }">
                    {{ t("app.common.month." + navigation.value) }}
                    </div>
                  </div>
                    }
                </div>
            </div>
        </ng-template>

        <ng-template #timeSelection>
            <div class="d-flex align-items-center justify-content-center">
                <ngb-timepicker formControlName="time" [hourStep]="1" [minuteStep]="15" [secondStep]="15"
                                [seconds]="displaySeconds"/>
                @if (displayMilliseconds) {
                <div class="ngb-tp-spacer ng-star-inserted">:</div>
                <div class="ngb-tp-input-container ngb-tp-minute">
                  <button tabindex="-1" type="button" class="btn btn-link ng-star-inserted"><span
                    class="chevron ngb-tp-chevron" (click)="onIncrementMilliseconds(100)"></span><span
                    class="visually-hidden">Increment milliseconds</span>
                  </button>
                  <input formControlName="milliseconds" class="ngb-tp-input form-control">
                  <button tabindex="-1" type="button" class="btn btn-link ng-star-inserted"
                          (click)="onIncrementMilliseconds(-100)"><span
                    class="chevron ngb-tp-chevron bottom"></span><span
                    class="visually-hidden">Decrement milliseconds</span>
                  </button>
                </div>
                }
            </div>
        </ng-template>
        @if (!hideErrorMessage) {
            @if (formControlName && (inputForm.touched || isTouched || ranges)) {
                @for (errorMessage of errors | errorMessages:formControlName;track errorMessage) {
                    <span class="errorMes pt-1">{{ errorMessage }}</span>
                }
            }
        }
    </form>
</ng-container>
